import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleRight } from '@fortawesome/free-solid-svg-icons';
import CustomButton from './button';

const ModalWrapper = ({
  title,
  subtitle,
  icon,
  buttonTitle,
  onClick,
}) => {
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClick();
    }
  };

  return (
    <div 
      className="fixed top-0 left-0 flex h-full w-full items-center justify-center bg-[rgba(0,0,0,0.5)] p-4 z-50"
      onClick={handleBackdropClick}
    >
      <div className="bg-white flex w-[400px] flex-col items-center rounded-lg px-6 py-8 shadow-lg">
        <div className="w-16 h-16 bg-[#FF8036] rounded-full flex items-center justify-center mb-4">
          {icon}
        </div>
        <h6 className="text-2xl font-bold mb-4">{title}</h6>
        <p className="text-gray-600 text-center mb-8">
          {subtitle}
        </p>
        <CustomButton
          text={buttonTitle}
          icon={<FontAwesomeIcon icon={faArrowAltCircleRight} />}
          iconPosition="right"
          onClick={onClick}
          bold
          big
        />
      </div>
    </div>
  );
};

export default ModalWrapper;